//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import type { BookmarkResponse } from './models/BookmarkResponse';
import type { CreateBookmarkDto } from './models/CreateBookmarkDto';
import type { GetUserBookmarksResponse } from './models/GetUserBookmarksResponse';
import { Utilities } from './Utilities';

export class BookmarksClient {
    private readonly http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> };
    private readonly baseUrl: string;
    public routes = {
        getUserBookmarks: (): string => {
            let clientRequestUrl = '/api/v3/bookmarks';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        createUserBookmark: (): string => {
            let clientRequestUrl = '/api/v3/bookmarks';
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        getById: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v3/bookmarks/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
        deleteBookmark: (
			id: number,
        ): string => {
            let clientRequestUrl = '/api/v3/bookmarks/{id}';
            if (id === undefined || id === null) {
                throw new Error(Utilities.parameterErrors.mustBeDefined('id'));
            }
            clientRequestUrl = clientRequestUrl.replace('{id}', encodeURIComponent(String(id)));
            clientRequestUrl = clientRequestUrl.replace(/[?&]$/, '');
            return clientRequestUrl;
        },
    };

    constructor(baseUrl: string, http: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }) {
        this.http = http;
        this.baseUrl = baseUrl ? baseUrl : '';
    }

    /**
     * Retrieves all bookmarks for the current user.
     * @return OK
     */
    async getUserBookmarks(): Promise<GetUserBookmarksResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getUserBookmarks();

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<GetUserBookmarksResponse>(_response, false, ['beginDate']);
    }

    /**
     * Creates a new bookmark for the current user.
     * @param body (optional) The details of the bookmark to create.
     * @return OK
     */
    async createUserBookmark(
        body?: CreateBookmarkDto,
    ): Promise<BookmarkResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.createUserBookmark();

        const content = JSON.stringify(body);

        const options = {
            body: content,
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<BookmarkResponse>(_response, false, ['beginDate']);
    }

    /**
     * Retrieves a specific bookmark by its ID.
     * @param id The ID of the bookmark to retrieve.
     * @return OK
     */
    async getById(
        id: number,
    ): Promise<BookmarkResponse> {
        const clientRequestUrl = this.baseUrl + this.routes.getById(
            id,
        );

        const options = {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<BookmarkResponse>(_response, false, ['beginDate']);
    }

    /**
     * Deletes a bookmark by its ID.
     * @param id The ID of the bookmark to delete.
     * @return No Content
     */
    async deleteBookmark(
        id: number,
    ): Promise<void> {
        const clientRequestUrl = this.baseUrl + this.routes.deleteBookmark(
            id,
        );

        const options = {
            method: 'DELETE',
            headers: {
            },
        } as RequestInit;

        const _response = await this.http.fetch(clientRequestUrl, options);
        return Utilities.processResponse<void>(_response, false, []);
    }
}
